import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "download-box pa-6 rounded-lg" }
const _hoisted_2 = { class: "d-flex justify-end" }

import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadBox',
  emits: ['download', 'cancel'],
  setup(__props, { emit: __emit }) {

const teamMaxNum = ref<number | null>(null)

const emits = __emit

return (_ctx: any,_cache: any) => {
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-h6 mb-4" }, "下载模板文件", -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_v_number_input, {
        modelValue: teamMaxNum.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((teamMaxNum).value = $event)),
        variant: "outlined",
        density: "compact",
        placeholder: "请输入每组最大人数",
        min: 0
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        color: "info",
        class: "mr-4",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('download', teamMaxNum.value)))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("下载")
        ])),
        _: 1,
        __: [3]
      }),
      _createVNode(_component_v_btn, {
        color: "red-lighten-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('cancel')))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("取消")
        ])),
        _: 1,
        __: [4]
      })
    ])
  ]))
}
}

})